import axios, { AxiosResponse } from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import moment from 'moment';

import {
    GET_APPOINTMENT_VISITOR_REQUEST,
    GET_APPOINTMENT_VISITOR_FAILURE,
    GET_APPOINTMENT_VISITOR_LIST_SUCCESS,
} from '../constants/appointment-visitor.constants';

const getvisitorListSuccess = (getAppointmentisitorListData: AnyIfEmpty<object>) => {
    return {
        type: GET_APPOINTMENT_VISITOR_LIST_SUCCESS,
        payload: getAppointmentisitorListData?.data,
        count: getAppointmentisitorListData?.count,
        page: getAppointmentisitorListData?.page,
    };
};

const getAppointmentVisitorListFailure = (appointmentError: AnyIfEmpty<object>) => {
    return {
        type: GET_APPOINTMENT_VISITOR_FAILURE,
        payload: appointmentError?.response?.data?.message,
    };
};

const getAppointmentVisitorRequest = () => {
    return {
        type: GET_APPOINTMENT_VISITOR_REQUEST,
    };
};

export const getAppointmentVisitorList = (
    appointmentDetails: {
        appointmentId: string;
        startRange?: string;
        endRange?: string;
        currentPage?: number;
        pageLimit?: number;
    },
    setShowPagination?: React.Dispatch<React.SetStateAction<boolean>>,
    setTempLoading?: React.Dispatch<React.SetStateAction<boolean>>,
) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getAppointmentVisitorRequest());
        axios
            .get('/locker', {
                params: {
                    appointmentId: appointmentDetails?.appointmentId,
                    startDateTime: appointmentDetails?.startRange
                        ? moment(appointmentDetails?.startRange, 'YYYY-MM-DD HH:mm:ss A').format('YYYY-MM-DD HH:mm:ss')
                        : '',
                    endDateTime: appointmentDetails?.endRange
                        ? moment(appointmentDetails?.endRange, 'YYYY-MM-DD HH:mm:ss A').format('YYYY-MM-DD HH:mm:ss')
                        : '',
                    page: appointmentDetails?.currentPage,
                    limit: appointmentDetails?.pageLimit,
                },
            })
            .then((response: AxiosResponse) => {
                if (response.data.statusCode === 200) {
                    response.data['page'] = appointmentDetails?.currentPage;
                    dispatch(getvisitorListSuccess(response.data));
                    setShowPagination?.(true);
                    setTempLoading?.(false);
                } else {
                    throw new Error(response.data.message);
                }
            })
            .catch((error) => dispatch(getAppointmentVisitorListFailure(error)));
    };
};